import { defineMessages } from 'react-intl';

export default defineMessages({
    notApplicable: {
        id: 'EAVehicleLevelCoveragesComponent.component.Not applicable',
        defaultMessage: 'Not applicable'
    }
});
